import { render, staticRenderFns } from "./downBottomImg.vue?vue&type=template&id=aa21bf5c&scoped=true"
import script from "./downBottomImg.vue?vue&type=script&lang=js"
export * from "./downBottomImg.vue?vue&type=script&lang=js"
import style0 from "./downBottomImg.vue?vue&type=style&index=0&id=aa21bf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa21bf5c",
  null
  
)

export default component.exports